import React, { Component } from 'react';
import {  Jumbotron, Button } from 'reactstrap';
import * as actions from '../../actions';
import { connect } from 'react-redux';

class Signout extends Component {

    signout

    render() {
        return (
            <div className="home">
                <div className="spacer-lg"></div>
                <div className="spacer-lg"></div>
                <Jumbotron>
                    <h1 className="display-3">Confirm Signout</h1>
                    <hr className="my-2" />
                    <div className="spacer-lg"></div>
                    <p className="lead">
                      <Button color="success" onClick={this.props.signoutUser}>Sign Out</Button>
                    </p>
                </Jumbotron>
            </div>
        )
    }
}

export default connect(null, actions)(Signout);



// WEBPACK FOOTER //
// ./src/pages/auth/signout.js